export default __webpack_public_path__ + "static/color-picker-accessible-role-do-8575d2ad7b4cc57cba33c1d843f8716ac8b2e31f98c0f677d91e4239b3e98aed.png";